// extracted by mini-css-extract-plugin
export default {"root":"ExtraFieldsSettings_root__HY5KA","add":"ExtraFieldsSettings_add__iMjJn"};